import example from './modules/example';

( function ( $ ) {
    'use strict';

    $( function() {
        example.init();
    } );

} )( jQuery );
